<template>
	<v-container fluid>
    <v-layout row wrap mx-4 mt-3>
      <v-flex md5>
        <p class="headline mt-3">Configuración de Plantilla {{ botTemplate.template_code }}</p>
      </v-flex>
      <v-flex md2 text-xs-right>
        <v-btn class="k-orange-linear white--text mr-0 mt-2" block large @click="editTemplate()">
          EDITAR PLANTILLA
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mx-4 mt-3>
      <v-flex xs12>
        <div id="bot-workflow"></div>
      </v-flex>
    </v-layout>
    <save-dialog
      :title="dialogTitle"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="true"
      :hasMore="false"
      :more="false"
      :scrollable="false"
      class-list="autocomplete-dialog-bot"
      :bus="dialogBus">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <textarea
              :ref="autoCompleteRef"
              v-model="text"
              v-validate="'required|max:10000'"
              data-vv-name="text"
              data-vv-as="texto"
              placeholder="Texto"
              @keydown.enter="avoidEmptyLines($event)"
              :class="{awesomplete: true, 'has-error': errors.has('text')}"
              data-multiple
              spellcheck="false">
            </textarea>
            <small class="p-absolute" id="text-error" v-if="errors.has('text')">
              {{ errors.first('text') }}
            </small>
          </v-flex>
        </v-layout>
        <v-btn id="fallback-button" @click="openSidebarForm()" flat v-if="hasFallback">Fallback</v-btn>
      </template>
    </save-dialog>
    <edit-bot></edit-bot>
    <right-drawer content="botFallback" :edit="true" :url="fallbackRoute" :bus="sideBarFormBus">
      <template slot="title">
       {{ dialogTitle }} Fallback
      </template>
    </right-drawer>
  </v-container>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import SVG from 'svg.js';
import svgFilter from '@/assets/js/svg.filter.min.js';
import image1 from '@/assets/img/bot-step-1.png';
import image2 from '@/assets/img/bot-step-2.png';
import image3 from '@/assets/img/bot-step-3.png';
import image4 from '@/assets/img/bot-step-4.png';
import image5 from '@/assets/img/bot-step-5.png';
import image7 from '@/assets/img/bot-step-7.png';
import image8 from '@/assets/img/bot-step-8.png';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import EventBus from '@/event-bus';
import autoCompleteMixin from '@/mixins/autoComplete';
import RightDrawer from '@/components/global/RightDrawer';
import BotFallback from '@/components/templateV2/BotFallback';
import EditBot from '@/components/templateV2/EditBot';
/* eslint-enable */

Vue.component('botFallback', BotFallback);

export default {
  components: {
    SaveDialog,
    RightDrawer,
    EditBot,
  },
  mixins: [
    saveDialogMixin,
    autoCompleteMixin,
  ],
  created() {
    EventBus.$on('update', () => {
      this.searchTemplate();
    });
    EventBus.$on('editItemBotWorkflow', (id, text, hasFallback, fallbackId) => {
      this.text = text;
      if (hasFallback) {
        this.hasFallback = true;
        this.fallbackRoute = `bot_template_details/${fallbackId}`;
      }
    });
    EventBus.$on('closeModalBotWorkflow', () => {
      this.hasFallback = false;
    });
    EventBus.$emit('update');
  },
  destroyed() {
    EventBus.$off('update');
    EventBus.$off('editItemBotWorkflow');
    EventBus.$off('closeModalBotWorkflow');
  },
  data() {
    return {
      drawer: {},
      cardsTexts: [],
      steps: [
        {
          title: 'Saludo inicial',
          name: 'text_1',
          id: 0,
          text: '',
          hasFallback: false,
          x: 0,
          y: 0,
        },
        {
          title: 'Confirmación del cliente',
          name: 'text_2',
          id: 0,
          text: '',
          hasFallback: true,
          fallbackName: 'fallback_2',
          fallbackId: 0,
          x: 0,
          y: 1,
        },
        {
          title: 'Cliente equivocado',
          name: 'text_3',
          id: 0,
          text: '',
          hasFallback: false,
          x: 1,
          y: 1,
        },
        {
          title: 'Mensaje de cobro',
          name: 'text_4',
          id: 0,
          text: '',
          hasFallback: false,
          x: 0,
          y: 2,
        },
        {
          title: 'Compromiso de pago',
          name: 'text_5',
          id: 0,
          text: '',
          hasFallback: true,
          fallbackName: 'fallback_5',
          fallbackId: 0,
          x: 0,
          y: 3,
        },
        {
          title: 'Despedida',
          name: 'text_7',
          id: 0,
          text: '',
          hasFallback: false,
          x: 1,
          y: 3,
        },
        {
          title: 'Fecha de compromiso',
          name: 'text_8',
          id: 0,
          text: '',
          hasFallback: true,
          fallbackName: 'fallback_8',
          fallbackId: 0,
          x: 0,
          y: 4,
        },
        {
          title: 'Despedida',
          name: 'text_9',
          id: 0,
          text: '',
          hasFallback: false,
          x: 0,
          y: 5,
        },
      ],
      lineStyles: {
        color: '#263238',
        width: '.2rem',
      },
      titlesFont: {
        size: '16px',
      },
      textsStyles: {
        size: '14px',
        fill: '#4a4a4a',
        'font-style': 'italic',
      },
      generalStyles: {
        cursor: 'pointer',
      },
      botTemplate: {},
      route: 'bot_template_details',
      fields: 'id,text,name',
      form: {
        text: '',
      },
      text: '',
      hasFallback: false,
      fallbackRoute: '',
      dialogTitle: '',
      autocompleteList: [
        'nombre_completo',
        'nombre',
        'apellido',
        'monto',
        'fecha_vencimiento',
        'moneda',
        'mañana',
      ],
      dialogBus: {
        created: 'createdBotWorkflow',
        modalOpened: 'modalOpenedBotWorkflow',
        showMore: 'showMoreBotWorkflow',
        editItem: 'editItemBotWorkflow',
        closeModal: 'closeModalBotWorkflow',
        openRightDrawer: 'openRightDrawerBotWorkflow',
      },
      sideBarFormBus: {
        sidebarFormError: 'sidebarFormErrorBotWorkflow',
        openRightDrawer: 'openRightDrawerBotWorkflow',
        rightDrawerSaved: 'rightDrawerSavedBotWorkflow',
        closeRightDrawer: 'closeRightDrawerBotWorkflow',
      },
    };
  },
  methods: {
    searchTemplate() {
      if (this.$route.params.botTemplate) {
        this.axios.get(`bot_templates/${this.$route.params.botTemplate}?fields=category,template_code,name,botTemplateDetails.id,botTemplateDetails.name,botTemplateDetails.text`)
          .then((response) => {
            const { bot_template_details, ...botTemplate } = response.data; // eslint-disable-line
            this.botTemplate = botTemplate;
            for (let i = 0; i < this.steps.length; i += 1) {
              const botTemplateDetail = bot_template_details.find(item => item.name === this.steps[i].name); // eslint-disable-line
              this.steps[i].id = botTemplateDetail.id;
              this.steps[i].text = botTemplateDetail.text;
              if (this.steps[i].hasFallback) {
                this.steps[i].fallbackId = bot_template_details.find(item => item.name === this.steps[i].fallbackName).id; // eslint-disable-line
              }
            }
            if (!Object.keys(this.drawer).length) {
              this.createSvg();
            } else {
              for (let i = 0; i < this.steps.length; i += 1) {
                const message = this.getShortedText(this.steps[i].text);
                this.cardsTexts[i].text(message);
                this.cardsTexts[i].x((145 + (this.steps[i].x * 400)) - (this.getTextWidth(message, 14) / 2)); // eslint-disable-line
                this.cardsTexts[i].y(120 + (this.steps[i].y * 230));
              }
            }
          }).catch(() => {});
      }
    },
    createSvg() {
      this.drawer = SVG('bot-workflow').size('100%', '100%');

      for (let i = 0; i < this.steps.length; i += 1) {
        const group = this.drawer.group();
        // Create card
        const card =
          this.drawer.rect(280, 110)
            .fill('#fff')
            .style(this.generalStyles)
            .move(this.steps[i].x * 400, 50 + (this.steps[i].y * 230));

        card.filter((add) => { // eslint-disable-line
          const blur1 = add.offset(0, 3).colorMatrix('matrix', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3, 0]).gaussianBlur(1);
          add.blend(add.source, blur1);
        });

        // Create image
        const image =
          this.drawer
            .image(this.getImage(i + 1), 60, 60)
            .style(this.generalStyles)
            .move((110 + (this.steps[i].x * 400)), (this.steps[i].y * 230));

        // Create title
        const title =
          this.drawer
            .text(this.steps[i].title)
            .style(this.generalStyles)
            .font(this.titlesFont)
            .move((145 + (this.steps[i].x * 400)) - (this.getTextWidth(this.steps[i].title, 16) / 2), 85 + (this.steps[i].y * 230)); // eslint-disable-line

        // Create text
        const message = this.getShortedText(this.steps[i].text);
        this.cardsTexts[i] =
          this.drawer
            .text(message)
            .style(this.generalStyles)
            .font(this.textsStyles)
            .move((145 + (this.steps[i].x * 400)) - (this.getTextWidth(message, 14) / 2), 120 + (this.steps[i].y * 230)); // eslint-disable-line

        group.add(card);
        group.add(image);
        group.add(title);
        group.add(this.cardsTexts[i]);
        group.click(() => {
          this.dialogTitle = this.steps[i].title;
          EventBus.$emit('editItemBotWorkflow', this.steps[i].id, this.steps[i].text, this.steps[i].hasFallback, this.steps[i].fallbackId);
        });

        if (i + 1 !== this.steps.length) {
          this.drawer.line(0, 0, 120 * this.steps[i].x, !this.steps[i].x ? 120 : 0)
            .move(140 * (this.steps[i].x + 1), 160 + (this.steps[i].y * 230) - (this.steps[i].x ? 55 : 0)) // eslint-disable-line
            .stroke(this.lineStyles);
        }
      }
    },
    getImage(i) { // eslint-disable-line
      switch (i) { // eslint-disable-line
        case 1:
          return image1;
        case 2:
          return image2;
        case 3:
          return image3;
        case 4:
          return image4;
        case 5:
          return image5;
        case 6:
          return image8;
        case 7:
          return image8;
        case 8:
          return image7;
      }
    },
    getTextWidth(text, font) {
      const element = document.createElement('canvas').getContext('2d');
      element.font = `${font}px Roboto, sans-serif`;
      return parseInt(element.measureText(text).width, 10);
    },
    getShortedText(text) {
      let shortedText = text;
      if (text.length > 30) {
        shortedText = `${String(text).substr(0, 27)}...`;
      }
      return shortedText;
    },
    editTemplate() {
      EventBus.$emit('editItemBotTemplate', this.botTemplate.id);
    },
  },
  watch: {
    text(newVal) {
      this.form.text = newVal;
    },
    'form.text'(newVal, oldVal) { // eslint-disable-line
      if (!oldVal || !newVal) {
        this.text = newVal;
      }
    },
    'form.bot_template_id'(newVal) { // eslint-disable-line
      if (!newVal) {
        this.form.bot_template_id = this.botTemplate.id;
      }
    },
  },
};
</script>

<style>
.autocomplete-dialog-bot > .card {
  height: 350px !important;
  overflow-y: hidden !important;
}

#fallback-button {
  bottom: 8px;
  left: 18px;
  position: absolute !important;
}
</style>

<style scoped>
#bot-workflow {
  height: 100rem;
}
</style>



// WEBPACK FOOTER //
// src/components/templateV2/BotWorkflow.vue